<template>
    <el-dialog title="注册" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-login dialog-register">
        <img src="../assets/images/close.png" alt="关闭" @click="closeHandler">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="el-form-diff" :label-width="formLabelWidth">
            <!---<el-form-item label="用户名：" prop="user_name">
                <el-input v-model="ruleForm.user_name" autocomplete="off" placeholder="请输入用户名(仅限字母、数字组合)"></el-input>
            </el-form-item>-->
            <el-form-item label="手机号：" prop="phone">
                <el-input v-model="ruleForm.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-row type="flex" justify="space-between">
                <el-form-item label="验证码：" class="dialog-input" prop="code">
                <el-input v-model="ruleForm.code" autocomplete="off" placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-button @click="sendSmsHandler" v-if="showTime" class="register-btn">获取验证码</el-button>
                <el-button v-else disabled class="register-btn" style="padding: 0;text-align: center;">{{count}}s后重新获取</el-button>
            </el-row>
            <el-form-item label="密码：" prop="password">
                <el-input v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码" :type="passwordType">
                <template slot="append">
                    <img :src="passwordImg[passwordType]" @click="changeShowPassword">
                </template>
                </el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="confirmPassword">
                <el-input v-model="ruleForm.confirmPassword" autocomplete="off" placeholder="请输入密码" :type="passwordType1">
                <template slot="append">
                    <img :src="passwordImg[passwordType1]" @click="changeShowPassword1">
                </template>
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="registerForm()">确定</el-button>
        </div>
        <div class="register-box">
            <span @click="goLogin">已有账号？去登录</span>
        </div>
    </el-dialog>
</template>

    <script>
        import { sendRegistSms } from "@/api/user";
        import { randomToken } from "@/utils/auth.js";
        export default {
        name: "Register",
        data() {
            const validateUserName = (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error("请输入用户名"));
                } else {
                    if ((/^[0-9a-zA-Z]*$/g.test(value))) {
                        callback();
                    } else {
                        callback(new Error("用户名必须是字母、数字组合"));
                    }
                }
            };
            const validatePhone = (rule, value, callback) => {
                if (value.length === 0) {
                callback(new Error("请输入手机号"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的手机号"));
                }
                }
            };
            const validateCode = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请输入验证码'));
                } else {
                callback();
                }
            };
            const validatePassword = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请输入密码'));
                } else {
                callback();
                }
            };
            const validateConfirmPassword = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请输入密码'));
                } else if(value != this.ruleForm.password){
                    callback(new Error('密码不一致'));
                } else {
                    callback();
                }
            };
            return {
                formLabelWidth: '105px',
                ruleForm: {
                    // user_name: '',
                    phone: '',
                    code: '',
                    password: '',
                    confirmPassword: '',
                },
                passwordImg:{
                    "text": require("../assets/images/show.png"),
                    "password": require("../assets/images/hidden.png"),
                },
                passwordType: 'password',
                passwordType1: 'password',
                passwordStr: false,
                passwordStr1: false,
                smsToken: '',
                count: '',
                timer: null,
                showTime: true,
                rules: {
                    // user_name: [
                       // { validator: validateUserName, trigger: 'blur', required: true }
                    // ],
                    phone: [
                        { validator: validatePhone, trigger: 'blur', required: true }
                    ],
                    code: [
                        { validator: validateCode, trigger: 'blur', required: true }
                    ],
                    password: [
                        { validator: validatePassword, trigger: 'blur', required: true }
                    ],
                    confirmPassword: [
                        { validator: validateConfirmPassword, trigger: 'blur', required: true }
                    ]
                },
                activeIndex: '0',
                titleList: ["密码登录","短信登录"],
            };
        },
        created () {
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields();
            })
        },
        methods: {
            sendSmsHandler() {
                this.smsToken = randomToken(32);
                sendRegistSms(this.ruleForm.phone,this.smsToken).then((res) => {
                if(res.status != 200) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                } else {
                    const TIME_COUNT = 179;
                    if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.showTime = false;
                    this.timer = setInterval(() => {
                        if (this.count > 1 && this.count <= TIME_COUNT) {
                        this.count--;
                        } else {
                        this.showTime = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        }
                    }, 1000)
                    }  
                }
                })
            },
            registerForm() {
                this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$store.dispatch('user/REGISTERUSER',{
                        user_name: this.ruleForm.phone,
                        mobile: this.ruleForm.phone,
                        sms_code: this.ruleForm.code,
                        sms_token: this.smsToken,
                        password: this.ruleForm.password
                    }).then((res) => {
                    }).catch(error => {
                        console.log(error);
                        this.$message.error(error);
                    })
                } else {
                    return false;
                }
                });
            },
            changeLoginType(index) {
                this.activeIndex = index;
            },
            changeShowPassword() {
                this.passwordStr = !this.passwordStr;
                this.passwordType = this.passwordStr ? 'text' : 'password';
            },
            changeShowPassword1() {
                this.passwordStr1 = !this.passwordStr1;
                this.passwordType1 = this.passwordStr1 ? 'text' : 'password';
            },
            goLogin() {
                this.$store.commit('user/REGISTER', false);
                this.$store.commit('user/LOGINSTATUS', true);
            },
            closeHandler() {
                this.$store.commit('user/REGISTER', false);
                this.$store.commit('user/LOGINSTATUS', false);
            },
        }
    }
    </script>

<style lang='scss' scoped>
    @import "@/assets/css/variables.scss";
    .dialog-box {
        img {
            width: 24px;
            height: 24px;
            position: absolute;
            right: 40px;
            top: 40px;
        }
        .active-line {
            width: 32px;
            height: 4px;
            background: #3272ff;
            border-radius: 2px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 15px;
        }
        .dialog-footer {
            padding: 0;
            button {
                width: 496px;
                height: 52px;
                background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
                border-radius: 8px;
                margin: 0 auto;
                font-size: 18px!important;
                color: #ffffff!important;
                position: absolute;
                bottom: 86px;
                left: 50%;
                border: none!important;
                transform: translateX(-50%);
            }
        }
        .register-box {
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translateX(-50%);
            color: $common-color;
            text-align: center;
            cursor: pointer;
        }
        .register-btn {
            text-align: center;
        }
    }
</style>